import $ from 'jquery';

$(() => {
  const els = $('.form input');
  const inputs = [];

  function checkProgress() {
    const inputFields = [];
    for (let n = 0; n < inputs.length; n++) { // eslint-disable-line no-plusplus
      if (!inputs[n].value.length) inputFields.push(inputs[n]);
    }
    const r = inputFields.length;
    const i = inputs.length;
    const progressBar = $('.progress-bar');
    const progressText = $('.form-progress .percent');
    for (let o = 0; o < progressBar.length; o++) { // eslint-disable-line no-plusplus
      progressBar[o].style.width = `${100 - ((r / i) * 100)}%`;
      progressText.html(`${100 - ((r / i) * 100)}%`);
    }
  }

  for (let j = 0; j < els.length; j++) { // eslint-disable-line no-plusplus
    if (els[j].type !== 'submit' && els[j].type !== 'checkbox' && els[j].type !== 'radio') {
      inputs.push(els[j]);
      els[j].addEventListener('input', checkProgress, false);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./src/js/progress-bar.js
 **/